import { render, staticRenderFns } from "./LabelStatistics.vue?vue&type=template&id=1a060174"
import script from "./LabelStatistics.vue?vue&type=script&lang=js"
export * from "./LabelStatistics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports